package org.vreo.devicehub.features.core.data.protocolBuffer.models

/**
 * Proto buf request type. GEt for requesting data from device and POST for sending data to device
 */
enum class ProtoBufRequestType {
    GET,
    POST
}